import { useCallback, useLayoutEffect, useState } from 'react';

export default function useRootSize(size = 375, font = 12, defaultMax = 10000) {
  const width = document.documentElement.clientWidth || document.body.clientWidth;
  const [windowWidth, setWindowWidth] = useState(
    document.documentElement.clientWidth || document.body.clientWidth
  );

  // vw 适配不再改 html font-size，避免与 CSS vw 叠乘
  useLayoutEffect(() => {
    if (width > defaultMax) {
      return;
    }
    const onResize = () => {
      if (width > defaultMax) {
        return;
      }
      setWindowWidth(document.documentElement.clientWidth || document.body.clientWidth);
    };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, [defaultMax, width]);

  const pxtorem = useCallback(
    n => {
      return `${(n / size) * 100}vw`;
    },
    [size]
  );

  // 数值版 vw 系数（无单位）；滚动等需实际像素时仍用 windowWidth 换算
  const pxtoremNpx = useCallback(
    n => {
      return `${(n / size) * windowWidth}`;
    },
    [size, windowWidth]
  );

  return {
    pxtorem,
    pxtoremNpx
  };
}
